module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTAiIGN5PSIxMCIgcj0iMTAiIGZpbGw9IiNBMEYwRTAiLz4KPGNpcmNsZSBjeD0iMTAiIGN5PSIxMy43NSIgcj0iMS4yNSIgZmlsbD0iIzMzMzMzMyIvPgo8cmVjdCB4PSI4Ljc1IiB5PSI1IiB3aWR0aD0iMi41IiBoZWlnaHQ9IjYuMjUiIHJ4PSIxLjI1IiBmaWxsPSIjMzMzMzMzIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-notice-arrow.svg
// module id = 5t+G
// module chunks = 1